// import { BuyAppAlertComponent } from './../../shared/components/buy-app-alert/buy-app-alert.component';
import { Appconfig } from './../enums/app-config';
import { Injectable } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Grid } from '../models/grid';
import { ModalSize } from '../enums/modal-info';
import Swal from 'sweetalert2';
import { CommonEnum } from '../enums/common';
import { EngineResult } from '../models/engine-result';
import { Router } from '@angular/router';
import { checkNullorUndefined } from '../utilities/functions/checknullorundefined';
import { AlertService } from './alert.service';
import { TimeoutComponent } from 'src/app/shared/components/timeout/timeout.component';
import { SessionService } from './session.service';
import { BehaviorSubject } from 'rxjs';
import { QuillEditorComponent } from 'ngx-quill';
import { BuyAppAlertComponent } from 'src/app/shared/components/buy-app-alert/buy-app-alert.component';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  breadCum: any = []
  myapps: any = [];
  modalReference: any;
  closeResult: string = '';
  hideControls: EngineResult = new EngineResult();
  modalReferenceApp: any;
  isRunning = false;
  mm: any = 0;
  ss: any = 0;
  ms: any = 0;
  hh: any = 0;
  dd: any = 0;
  pmm: any = 0;
  pss: any = 0;
  pms: any = 0;
  phh: any = 0;
  currentbfeM_Id: any = '';
  pause = false;
  isPaused: boolean = false;
  params: any;
  currentAppCode: any = 'A01.KS';
  acclist: any;
  myAppsList: any = [];
  lmportaltermsAgreed: boolean = false;
  exprireTime: number = 0;
  currentTime: number = 0;
  currentSupportTopic: any = '';
  supportPageIndex: number = 1;
  currentRoompage: any = '';
  currentSeconds: number = 0;
  modalRef!: import("@ng-bootstrap/ng-bootstrap").NgbModalRef;
  loginTime: Date = new Date();
  trailInfo: string = '';
  timerId: any = '';
  loginTimerId: any = '';
  openAIFeedModel: any = false;
  remainingMinutes: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  remainingSeconds: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  remainingHours: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  showTimerConfrm: boolean = false;
  showTimerConfrmOpened: boolean = false;
  AppcodeNotificationsData: any = [];
  NotificationsCount: number = 0;
  walletAmount: number = 0;
  quillFormats: any = [
    'background',
    'bold',
    'font',
    'code',
    'italic',
    'link',
    'size',
    'strike',
    'script',
    'underline',
    'blockquote',
    'header',
    'indent',
    'list',
    'align',
    'direction',
    'code-block',
    // 'image'
    // 'video'
  ];
  quillEditor: QuillEditorComponent;

  constructor(private modalService: NgbModal,
    private sessionService: SessionService,
    private router: Router,
  ) { }
  // 

  public editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'], ['link'],
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
      // [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
      // [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction
      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      // [{ 'color': [] as any }, { 'background': [] as any }],          // dropdown with defaults from theme
      // [{ 'font': [] as any }],
      // [{ 'align': [] as any }],

      // ['clean']                                         // remove formatting button

      // ['link', 'image', 'video']                         // link and image, video
    ],
    // latex: true
    // imageResize: {
    //   displaySize: true,
    // },
    // autoLink: true,
  };

  editorStyle: any;
  currenturl: any;

  getTextFromHTML(htmlText: string) {
    // Create a new DOM element
    const tempElement = document.createElement('div');
    // Set the innerHTML of this element to the htmlText
    tempElement.innerHTML = htmlText;
    // Extract and return the text content from this element
    const text = tempElement.textContent || '';
    return text.replace('&nbsp;', ' ');
  }

  getTextFromJson(JsonText: string): string {
    try {
      const jsonObject = JSON.parse(JsonText);
      let texts: string[] = [];
      for (const item of jsonObject) {
        let text = item?.data?.text ?? item?.text ?? '';
        // Remove HTML tags and replace &nbsp; with space
        text = text.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ');
        texts.push(text.trim());
      }
      // Join each text with a newline for better readability
      return texts.filter(Boolean).join('\n');
    } catch (error) {
      return '';
    }
  }

  setToken(token: string) {
    localStorage.setItem(Appconfig.CURRENTJWTTOKEN, JSON.stringify(token));
  }
  getToken() {
    return JSON.parse(localStorage.getItem(Appconfig.CURRENTJWTTOKEN) as string);
  }
  setUserDetails(userDetails: any) {
    localStorage.setItem(Appconfig.CURRENTUSER, JSON.stringify(userDetails));
  }
  getUserDetails() {
    return JSON.parse(localStorage.getItem(Appconfig.CURRENTUSER) as any);
  }
  removeUserDetails() {
    localStorage.removeItem(Appconfig.CURRENTUSER);
  }
  getMenu() {
    this.myAppsList = JSON.parse(localStorage.getItem(Appconfig.MYAPPS) || 'null');
    return this.myAppsList;
  }
  setAppConfig(config: any) {
    localStorage.setItem(Appconfig.APPCONFIG, JSON.stringify(config));
  }
  setConfigProps(props: any[]) {
    this.hideControls.controlProperties = props;
  }
  getConfigProps() {
    return this.hideControls.controlProperties;
  }
  setMenu(menu: any) {
    localStorage.setItem(Appconfig.MYAPPS, JSON.stringify(menu));
  }
  setSubMenu(menu: any) {
    localStorage.setItem(Appconfig.MYSUBMENU, JSON.stringify(menu));
  }
  getYear() {
    const d = new Date();
    return d.getFullYear();
  }
  // gotoHomePage() {
  //   if(this.getUserDetails()){
  //   this.router.navigate([RedirectRoutes.DASHBOARD]);
  //   }else{
  //     this.logOut();
  //   }
  // }

  loginTimerRun() {
    var startTimeDetails = this.getloggedInTime();
    const end = startTimeDetails?.expireDate;
    const diffInMs: any = new Date(end).valueOf() - new Date().valueOf();
    // const diffInMs: any = Math.abs(new Date(end).valueOf() - new Date().valueOf());
    this.remainingHours.next(Math.floor(diffInMs / (1000 * 60 * 60)));
    this.remainingMinutes.next(Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60)));
    this.remainingSeconds.next(Math.floor((diffInMs % (1000 * 60)) / 1000));
    // if(this.remainingHours.value == 0 && this.remainingMinutes.value == 0 && this.remainingSeconds.value == 0 ){
    if (this.remainingHours.value == 0 && this.remainingMinutes.value == 0 && this.remainingSeconds.value == 0) {
      this.sessionService.logOut();
    }
    this.sessionService.remainingSessHours = this.remainingHours.getValue();
    this.sessionService.remainingSessMinutes = this.remainingMinutes.getValue();
    this.sessionService.remainingSessSeconds = this.remainingSeconds.getValue();
    let obj = { remainingHours: this.remainingHours.getValue(), remainingMinutes: this.remainingMinutes.getValue(), remainingSeconds: this.remainingSeconds.getValue() };
    localStorage.setItem("LoginTimer:", JSON.stringify(obj));
    if (this.remainingMinutes.getValue() < 0) {
      this.showTimerConfrm = false;
      this.showTimerConfrmOpened = false;
      this.remainingMinutes.next(0);
      this.remainingSeconds.next(0);
      this.sessionService.logOut();
    }
    if (this.remainingHours.getValue() == 0 && this.remainingMinutes.getValue() == 5) {
      this.showTimerConfrm = true;
    }
    else {
      this.showTimerConfrm = false;
      // this.showTimerConfrmOpened = false;
    }
    if (this.showTimerConfrm && !this.showTimerConfrmOpened) {
      this.modalRef = this.modalService.open(TimeoutComponent,
        {
          size: 'md',
          backdrop: "static",
          centered: true
        });
      this.showTimerConfrmOpened = true;
    }
  }

  getRoute(url: string) {
    if (url != '') {
      this.router.navigate([url]);
    }
  }

  getDataDiff(start: Date, end: any, obj: any) {
    if (start.getDate()) {
      if (end == null) {
        end = new Date();
      }
      if (obj) {
        start.setDate(start.getDate() + obj?.days);
        start.setHours(start.getHours() + obj?.hours);
        start.setMinutes(start.getMinutes() + obj?.minutes);
        start.setSeconds(start.getSeconds() + obj?.seconds);
      }
      const diff: any = Math.abs(start.valueOf() - end.valueOf());
      let diffDays = Math.floor(diff / (60 * 60 * 24 * 1000));
      let diffHours = Math.floor(diff / (60 * 60 * 1000));
      let diffMinutes = Math.floor(diff / (60 * 1000)) - ((diffHours * 60));
      let diffSeconds = Math.floor(diff / 1000) - ((diffHours * 60 * 60) + (diffMinutes * 60));
      if (diffDays) {
        this.dd = diffDays;
      }
      if (diffHours) {
        this.hh = diffHours;
      }
      if (diffMinutes) {
        this.mm = diffMinutes;
      }
      if (diffSeconds) {
        this.ss = diffSeconds;
      }
      let obj2 = { days: this.dd, hours: this.hh, minutes: this.mm, seconds: this.ss };
      localStorage.setItem("TaskTimer:", JSON.stringify(obj2));
    }
  }

  clearTimeInterval() {
    clearInterval(this.timerId);
  }
  clearLoginTimeInterval() {
    clearInterval(this.loginTimerId);
  }

  // secondsToMinutesAndSeconds(seconds: number) {
  //   this.remainingMinutes = Math.floor(seconds / 60);
  //   this.remainingSeconds = Math.floor(seconds % 60);
  //   let obj = { minutes: this.remainingMinutes, seconds: this.remainingSeconds }
  //   localStorage.setItem('LoginTimerDetails', JSON.stringify(obj));
  // }
  // Grid

  //fqa serial number grid
  onGenerateJson(response: any, grid: Grid) {
    let jsonResponse: any;
    let elements: any = [];
    let ChildElements: any = [];
    let jsonData: any = {};
    let columnNames = [];
    let colValues: any = [];
    let result: any = {};
    // if (this.masterPageService.hideControls && this.masterPageService.hideControls.controlProperties) {
    // // if (this.masterPageService.hideControls.controlProperties.import) {
    // // grid.ImportVisible = true;
    // // }
    // // if (this.masterPageService.hideControls.controlProperties.export) {
    // // grid.ExportVisible = true;
    // // }
    // // if (this.masterPageService.hideControls.controlProperties.hideSearch) {
    // // grid.SearchVisible = false;
    // // }
    // }
    if (
      !checkNullorUndefined(this.getConfigProps()) &&
      this.getConfigProps().hasOwnProperty('configs') &&
      this.getConfigProps().configs.hasOwnProperty('title')
    ) {
      grid.title = this.getConfigProps().configs['title']
    }
    jsonResponse = {
      SearchVisible: grid.SearchVisible,
      title: grid.title,
      SortDisabled: grid.SortDisabled,
      ItemsPerPage: grid.ItemsPerPage,
      EditVisible: grid.EditVisible,
      EditAccess: grid.EditAccess,
      DeleteAccess: grid.DeleteAccess,
      SendVisible: grid.SendVisible,
      AddLinesVisible: grid.AddLinesVisible,
      SplitTrxVisible: grid.SplitTrxVisible,
      AddSettingsVisible: grid.AddSettingsVisible,
      launchVisible: grid.launchVisible,
      makeVisible: grid.makeVisible,
      ImportVisible: grid.ImportVisible,
      ExportVisible: grid.ExportVisible,
      refreshGrid: grid.refreshGrid,
      EditHighlight: grid.EditHighlight,
      DeleteVisible: grid.DeleteVisible,
      WalletVisible: grid.WalletVisible,
      ManageVisible: grid.ManageVisible,
      ViewVisible: grid.ViewVisible,
      CloseVisible: grid.CloseVisible,
      ShowCheckbox: grid.ShowCheckbox,
      CheckboxChecked: grid.CheckboxChecked,
      TaskInfoVisible: grid.TaskInfoVisible,
      PaginationVisible: grid.PaginationVisible,
      PaginationId: Date.now(),
      totalRecods: grid.totalRecods,
      Elements: response,
      chatVisible: grid.chatVisible,
      addTocart: grid.addTocart,
      shortList: grid.shortList,
      selected: grid.selected,
      addTofavourite: grid.addTofavourite,
      rating: grid.rating,
      addToCrm: grid.addToCrm,
      goToCrm: grid.goToCrm,
      goToEC: grid.goToEC,
      ShowToggle: grid.ShowToggle,
      toggleChecked: grid.toggleChecked,
    };
    return jsonResponse;
  }

  hideModel() {
    if (this.modalReference) {
      this.modalReference.close()
    }
  }

  // Model Pop-up

  openXl(content: any, size: any, callback: any) {
    // if (size === ModalSize.DAILOG_EXTRA_LARGE || size === ModalSize.DAILOGLARGE || size === ModalSize.DAILOGMEDIUM || size === ModalSize.DAILOGSMALL) {
    //   this.modalReference = this.modalService.open(content, {
    //     windowClass: 'modal-holder',
    //     keyboard: false,
    //     size: size,
    //     backdrop: 'static',
    //   });
    // ...

    // ...

    if (size === ModalSize.DAILOG_RIGHT) {
      this.modalReference = this.modalService.open(content, {
        // size: size,
        keyboard: false,
        backdrop: 'static',
        scrollable: true,
        windowClass: ModalSize.DAILOG_RIGHT
      });
    } else {
      this.modalReference = this.modalService.open(content, {
        windowClass: 'modal-holder',
        keyboard: false,
        size: size,
        scrollable: true,
        backdrop: 'static'
      });
    }
    this.modalReference.result.then(
      (result: any) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    callback(this.modalReference);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closePopup(message: any, callback: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: message,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES,
    }).then((result: any) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
        // this.hideModal();
      }
    });
  }


  openBuyApp(app: any, type: any) {
    let showSub = this.checkSubscriptionTime(app.appCode);
    let trailInfo = '';
    if (showSub == true) {
      trailInfo = this.trailInfo;
    }
    this.modalReferenceApp = this.modalService.open(BuyAppAlertComponent, {
      windowClass: 'modal-holder',
      keyboard: false,
      size: ModalSize.DAILOGSMALL,
      backdrop: 'static',
    });
    this.modalReferenceApp.componentInstance.appData = app;
    this.modalReferenceApp.componentInstance.trailInfo = trailInfo;
    this.modalReferenceApp.componentInstance.currentUser = this.getUserDetails();
    this.modalReferenceApp.componentInstance.type = type;
    this.modalReferenceApp.result.then((result: any) => {
      if (result == 'Save click') {
      } else {
        this.modalReferenceApp.dismiss();
      }
    })
  }

  notSubscribed(appCode: string) {
    if (this.getUserDetails().userType == 'HT') {
      return true;
    }
    else {
      const data = this.getMenu().find((c: any) => c.appCode == appCode);
      if (data) {
        if (data.isInstalled) {
          if (data.isTrail && !data.isSubscribed) {
            let future = new Date(data.trailTo);
            if (future >= new Date()) {
              return true;
            } else {
              this.openBuyApp(data, 'installed');
              return false;
            }
          }
          else if (!data.isTrail && data.isSubscribed) {
            let future = new Date(data.subscriptionTo);
            // future.setDate(future.getDate() + 20);
            future.setDate(future.getDate());
            if (future >= new Date()) {
              return true;
            } else {
              this.openBuyApp(data, 'installed');
              return false;
            }
          } else {
            this.openBuyApp(data, 'installed');
            return false;
          }
        }
        else if (!data.isInstalled) {
          this.openBuyApp(data, 'notInstalled');
        }
      }
      // else {
      //   if (appCode == 'A10.AC') {
      //     this.openBuyApp('Workflow', 'installed');
      //   }
      //   return false;
      // }
    }
    return false;
  }


  setCurrentappCode(appCode: string) {
    this.currentAppCode = appCode;
    localStorage.setItem(Appconfig.CURRENT_APPCODE, appCode);
  }

  getCurrentappCode() {
    return localStorage.getItem(Appconfig.CURRENT_APPCODE);
  }
  getloggedInTime() {
    const loggedInTime = localStorage.getItem('loggedInTime');
    return loggedInTime ? JSON.parse(loggedInTime) : null;
  }
  checkSubscribed(appCode: string, fromRoute = false) {
    if (this.getUserDetails().userType == 'HT') {
      return true;
    }
    else {
      const data = this.getMenu().find((c: any) => c.appCode == appCode);
      if (data) {
        if (data.isInstalled) {
          if (data.isTrail && !data.isSubscribed) {
            let future = new Date(data.trailTo);
            if (future >= new Date()) {
              return true;
            } else {
              // this.openBuyApp(data, 'installed');
              return false;
            }
          }
          else if (!data.isTrail && data.isSubscribed) {
            let future = new Date(data.subscriptionTo);
            // future.setDate(future.getDate() + 20);
            future.setDate(future.getDate());
            if (future >= new Date()) {
              return true;
            } else {
              // this.openBuyApp(data, 'installed');
              return false;
            }
          } else {
            // this.openBuyApp(data, 'installed');
            return false;
          }
        }
        else if (!data.isInstalled) {
          // this.openBuyApp(data, 'notInstalled');
        }
      }
      else {
        if (appCode == 'A10.AC') {
          // this.openBuyApp('Workflow', 'installed');
        }
        return false;
      }
    }
    return false;
  }

  checkSubscriptionTime(appCode: string) {
    let data: any = this.getMenu();
    if (data) {
      data = this.getMenu().find((c: any) => c.appCode == appCode);
    }
    this.trailInfo = "";
    let today = new Date()
    if (data) {
      if (data.isTrail && !data.isSubscribed) {
        let future = new Date(data.trailTo);
        if (future >= new Date()) {
          const diffTime: any = Math.abs(future.valueOf() - today.valueOf());
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays <= 5) {
            this.trailInfo = `Please subscribe - ${data.name} App trial period will expire in ${diffDays} day(s).`
            return true;
          } else {
            this.trailInfo = "";
            return false;
          }
        } else {
          this.trailInfo = "";
          return false;
        }
      }
      else if (!data.isTrail && data.isSubscribed) {
        let future = new Date(data.subscriptionTo);
        if (future >= new Date()) {
          const diffTime: any = Math.abs(future.valueOf() - today.valueOf());
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays <= 5) {
            this.trailInfo = `Please subscribe - ${data.name} App subscrption will expire in ${diffDays} day(s).`
            return true;
          } else {
            this.trailInfo = "";
            return false;
          }
        } else {
          future.setDate(future.getDate());
          const diffTime: any = Math.abs(future.valueOf() - today.valueOf());
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          // if (diffDays <= 20) {
          this.trailInfo = `Please subscribe - ${data.name} App subscrption was expired ${Math.abs(diffDays)} day(s) ago.`
          return true;
          // }
          return false;
        }
      } else {
        this.trailInfo = "";
        return false;
      }
    }
    return false;
  }

  checkMainRole() {
    let getCurrentUser = this.getUserDetails().mainRole;
    if (getCurrentUser == 'User') {
      return false;
    }
    return true
  }

  tagsInput(event: any, type: any, maxLength = 0) {
    let value = event.target.value;
    if (type === 'email') {
      if (value) {
        if (value.includes(',')) {
          let emails = value.split(',');
          if (emails.length > maxLength) {
            event.target.value = emails.slice(0, maxLength).join(',');
          }
        }
      }
    }

  }
  // hideModal(button = 'Update'){
  //   if(button === 'Update'){
  //     this.modalReference.close();
  //   }
  // }

  // appConfig: any = 'QuickBooks';

  // checkDomain() {

  //   if (window.location.hostname.includes('test.fbapps')) {
  //     this.appConfig = 'FreshBooks'
  //   }
  //   else if (window.location.hostname.includes('localhost')) {
  //     this.appConfig = 'TestBooks'
  //   }
  //   return this.appConfig;
  // }


  //The set method is use for encrypt the value
  // encrypt(value: string, securityKey) {
  //   if (value && securityKey) {
  //     let key = CryptoJS.enc.Utf8.parse(securityKey);
  //     let iv = CryptoJS.enc.Utf8.parse(securityKey);
  //     var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key,
  //       {
  //         keySize: 128 / 8,
  //         iv: iv,
  //         mode: CryptoJS.mode.CBC,
  //         padding: CryptoJS.pad.Pkcs7
  //       });

  //     return encrypted.toString();
  //   }
  // }



  //The get method is use for decrypt the value.
  // decrypt(keys, value) {
  //   if (keys && value) {
  //     var key = CryptoJS.enc.Utf8.parse(keys);
  //     var iv = CryptoJS.enc.Utf8.parse(keys);
  //     var decrypted = CryptoJS.AES.decrypt(value, key, {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     });
  //     return decrypted.toString(CryptoJS.enc.Utf8);
  //   }
  // }
  // getAccountantsList() {
  //   return [];
  // }

}
